import * as THREE from 'three'
import Experience from '../index'

export default class Environment {
  constructor() {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.camera = this.experience.camera.camera
    this.resources = this.experience.resources

    this.createLights()
  }

  createLights() {
    this.pointLight = new THREE.PointLight(0xffffff, 100, 0)
    this.pointLight.position.set(0, 2, 2.5)
    this.camera.add(this.pointLight)

    this.ambientLight = new THREE.AmbientLight(0xffffff, 0.5)
    this.scene.add(this.ambientLight)
  }
}
